export default __webpack_public_path__ + "static/media/lacessories13.6e7fe05e.jpeg";